import * as React from 'react';
import { ChangeEvent } from 'react';
import { AppContext, AppContextType } from '../../AppContextType';
import { JobVacancy } from '../../Model/JobVacancy';
import { Sector } from '../../Model/Sector';
import { SectorSelectBox } from '../Form/SectorSelectBox';
import { FilterViewProps } from './FilterViewProps';

export class SectorFilter<T extends JobVacancy> extends React.PureComponent<FilterViewProps<T>> {
    public static contextType = AppContextType;
    public context: AppContext = {} as AppContext;

    constructor(props: FilterViewProps<T>, context: any) {
        super(props, context);
        this.handleChange = this.handleChange.bind(this);
    }

    public render() {
        const props = this.props;

        return <SectorSelectBox valueId={props.filterSettings.sectorId}
                                models={props.models}
                                placeholder={this.context.i18n.translate("Branche")}
                                onChange={this.handleChange}/>;
    }

    private handleChange(value: Sector | undefined, _event: ChangeEvent<HTMLSelectElement>) {
        const props = this.props;

        props.onChange(props.filterSettings.withSectorId(value ? value.referenceId : undefined));
    }
}
